import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Resets window scroll to the top on every route change. React Router doesn't do this itself
 * (unlike a full page navigation), so without it the new page inherits whatever scroll position
 * the previous page was left at — e.g. clicking a sidebar link while scrolled down on Event
 * Management would land on Home already scrolled past its header.
 *
 * Keyed on pathname only (not search/hash) so paginating via query params or jumping to an
 * in-page anchor doesn't get fought by this effect.
 */
export function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}
